/**
 * @citeclerk/plan/promptPricing — ESM entry point.
 *
 * 🔴 THIS FILE HOLDS NO TEXT AND NO NUMBERS. It re-exports promptPricing.cjs, which is the ONE
 * renderer. Same reasoning as index.mjs: named destructuring of the default export rather than
 * `export *`, so a shape change fails loudly at import time instead of quietly reducing the named
 * exports to nothing.
 */
import promptPricing from './promptPricing.cjs';

export const {
  renderPlansSection, PLANS_AND_PRICING_MD, usd, maxAnnualSavingPct,
} = promptPricing;

export default promptPricing;
